import React from 'react';
import { MainContent } from './layout/main-content-container';
import { PageContainer } from './layout/page-container';
import { WysiwygWithReactLink } from './wysiwyg-with-react-link';


export interface Props {
	message: string;
}

export function MaintenancePage(props: Props) {

	return (
		<PageContainer>
			<MainContent>
				<WysiwygWithReactLink content={props?.message} />
			</MainContent>
		</PageContainer>
	);
}